import React from 'react';
import { colors } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import GlobeIllustration from 'svg/illustrations/Globe';
import { enProduccionConMemForegroundOnPage } from '../enProduccionConMemReadableText';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const Benefits = () => {
  const theme = useTheme();
  const headingColor = enProduccionConMemForegroundOnPage(theme);
  const sections = [
    {
      title: 'Marcas y storytelling',
      subtitle:
        'Narrativas de producto, lanzamientos y reputación. Ideal para retail, consumo masivo y servicios con propuesta de valor clara.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
          />
        </svg>
      ),
      color: colors.blueGrey,
    },
    {
      title: 'Medios y performance',
      subtitle:
        'Inversión en pauta, canales y métricas explicados sin tecnicismo vacío. Ideal para agencias, plataformas y B2B.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
          />
        </svg>
      ),
      color: colors.green,
    },
    {
      title: 'Industria y talento',
      subtitle:
        'Cultura creativa, producción y relación con la audiencia. Ideal para estudios, consultoras y marcas en crecimiento.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
      ),
      color: colors.brown,
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium', color: headingColor }}
          gutterBottom
          align="center"
        >
          Territorios de contenido
        </Typography>
        <Box
          component={Typography}
          sx={{ fontWeight: 700, fontFamily: 'Georgia, "Times New Roman", serif', color: headingColor }}
          variant="h3"
          gutterBottom
          align="center"
        >
          Premium alineado a tu categoría
        </Box>
        <Typography align="center" color="textSecondary" variant="h6">
          Tres pilares editoriales para conectar patrocinio con contexto real: marcas, medios y talento creativo.
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" marginBottom={4} data-aos="fade-up">
        <Box maxWidth={300} width="100%">
          <GlobeIllustration width="100%" height="100%" />
        </Box>
      </Box>
      <Grid container spacing={4}>
        {sections.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              height={1}
              display="flex"
              flexDirection="column"
              data-aos="fade-up"
              data-aos-delay={i * 100}
            >
              <Box display="flex" justifyContent="flex-start" alignItems="center" marginBottom={2}>
                <Box
                  component={Avatar}
                  width={60}
                  height={60}
                  marginRight={2}
                  bgcolor={item.color[50]}
                  color={item.color[900]}
                >
                  {item.icon}
                </Box>
                <Box>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                    {item.title}
                  </Typography>
                </Box>
              </Box>
              <Typography color="textSecondary">{item.subtitle}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default Benefits;
